import { readLanguageCookie } from './cookies';

const DEFAULT_SOURCE_LANGUAGE = 'en';

/**
 * Reading stored listing translations on the display side.
 *
 * Moved here from the host marketplace (`src/util/listingTranslations.js`): it
 * carried no marketplace-specific logic, so every new marketplace would have
 * had to reimplement the same cookie-read + fallback.
 */

/**
 * The language the visitor is currently browsing in (the `emp_lang` cookie set
 * by LanguageSelector). Null on the source language, meaning "use the
 * listing's own attributes".
 *
 * @param {string} [defaultSource] the tenant's source language
 */
export const currentTranslationLanguage = (defaultSource = DEFAULT_SOURCE_LANGUAGE) => {
  const language = readLanguageCookie();
  return language && language !== defaultSource ? language : null;
};

/**
 * `{ title, description }` for a listing in the visitor's current language.
 *
 * Falls back to the source attributes whenever a translation is missing — most
 * listings are only partially translated, and a blank card is far worse than an
 * English one. The fallback is per FIELD, not per listing, so a listing with a
 * translated title but no translated description still shows both.
 *
 * @param {Object} listing listing entity
 * @param {string} [defaultSource] the tenant's source language
 * @returns {{ title: string, description: string }}
 */
export const translatedListingFields = (listing, defaultSource = DEFAULT_SOURCE_LANGUAGE) => {
  const { title = '', description = '', publicData = {} } = listing?.attributes || {};
  const language = currentTranslationLanguage(defaultSource);
  const translation = language ? publicData.translations?.[language] : null;
  return {
    title: translation?.title || title,
    description: translation?.description || description,
  };
};
